import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Breadcrumbs.tsx");
